module.exports = __webpack_public_path__ + "img/Bookmarkkedsaved.973ba5fb.png";